import { SystemUiconsMailNew } from '../../../assets/icons/Icons'
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import EmptyData from '../../ui/EmptyData';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedChapel } from '../../../features/chapel/chapelSlice';
import { selectIsFetching, setTypeModal, setTypeOfShowModalType } from '../../../features/modal/modalSlice';
import { Chapel } from '../../../types/package';

interface ChapelListProps {
    data: Chapel[];
    isLoading: boolean;
    isError: boolean;
    errorMessage: string
}

export default function ChapelList({ data, isLoading, isError, errorMessage }: ChapelListProps) {
    
    const dispatch = useDispatch();
    const isFetching = useSelector(selectIsFetching)
    const isCurrentlyLoading = isLoading || isFetching

    const handleSelectChapel = (chapel: Chapel) => {
        dispatch(setTypeModal('updateChapel'));
        dispatch(setTypeOfShowModalType('chapelModal'));
        dispatch(setSelectedChapel(chapel));
    }

    return (
        <div className='overflow-hidden h-full rounded'>
            <div className='p-2 h-full rounded overflow-y-auto'>
                { isCurrentlyLoading ? (
                    <div className='flex justify-center items-center h-full'>
                        <Loading message="Loading chapel..." />
                    </div>
                ) : isError ? (
                    <div className='flex justify-center items-center h-full'>
                        <ErrorMessage message={errorMessage} textStyle='text-red-500 text-sm'/>
                    </div>
                ) : data.length === 0 ? (
                    <div className='flex justify-center items-center h-full'>
                        <EmptyData message="No chapels available." />
                    </div>
                ) : (
                    <div className='grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-3 lg:grid-cols-5 lg:gap-3 overflow-hidden'>
                        {data.map((dat) => (
                            <div
                                onClick={() => handleSelectChapel(dat)}
                                key={dat.chapelID}
                                className='rounded border-t-8 border-cbColor cursor-pointer'
                            >
                                <div className='border border-gray-200 flex flex-col p-2.5 space-y-1 rounded-b bg-gray-100'>
                                    <div className='flex justify-between items-center'>
                                        <p className='text-sm text-black font-semibold truncate'>
                                            {dat.chapelName}
                                        </p>
                                        <span>
                                            <SystemUiconsMailNew color='#aaadab' height={33} width={33} />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
